<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-tabs class="mt-3" v-model="type" @tab-click="handleClick" type="card">
		   <el-tab-pane  :label="$t('liveModel.tran')" name="tran"></el-tab-pane>
		   <el-tab-pane  :label="$t('live.zTran')" name="ztran"></el-tab-pane>
		   <el-tab-pane  :label="$t('live.recordModel')" name="record"></el-tab-pane>
		   
		 </el-tabs>
		
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('live.modelName')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>

						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('liveModel.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<!-- 转码模版 -->
			<el-table v-show="type=='tran'" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" >
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				
				
				
				
				<el-table-column prop="name" align="center" :label="$t('live.modelName')" >
					<template slot-scope="scope">
						{{scope.row.key}}{{scope.row.name}}
					</template>
				</el-table-column>
												
												
				
				<el-table-column align="center"  prop="user_name" :label="$t('cdn.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				<el-table-column   prop="date" align="center" :label="$t('live.modelType')" >
				   <template slot-scope="scope">
						<span v-if="scope.row.video_type==1">{{$t('live.videoType1')}}</span>
						<span v-if="scope.row.video_type==2">{{$t('live.videoType2')}}</span>
				   </template>
				</el-table-column>
				<el-table-column  prop="date" align="center" :label="$t('live.ma_type')" >
					   <template slot-scope="scope">
							<span v-if="scope.row.code_type==264">H.264</span>
							<span v-if="scope.row.code_type==265">H.265</span>
					   </template>
				</el-table-column>
				<el-table-column   prop="date" align="center" :label="$t('live.videoBitrate')" >
					   <template slot-scope="scope">
							<span v-if="scope.row.ma_type==1">{{scope.row.ma_value}} kbps</span>
							<span v-if="scope.row.ma_type==2">{{$t('live.setMa2')}}</span>
					   </template>
				</el-table-column>
				<el-table-column width="300" prop="date" align="center" :label="$t('live.fenbianlv')"  >
				   <template slot-scope="scope">
					   
					   <span v-if="scope.row.wh_type==1">
						   <span>{{$t('live.height')}}：{{scope.row.wh_value}} px</span>&nbsp;
						   <span>{{$t('live.width')}}</span>
					   </span>
					   <span v-if="scope.row.wh_type==2">{{$t('live.setWH2')}}</span>
					   
					   
					
					
				   </template>
												
				</el-table-column>
				
				<el-table-column   prop="date" align="center" :label="$t('live.videoFrameRate')" >
					   <template slot-scope="scope">
							<span v-if="scope.row.z_type==1">{{scope.row.z_value}} fps</span>
							<span v-if="scope.row.z_type==2">{{$t('live.setZ2')}}</span>
					   </template>
				</el-table-column>
				
				<el-table-column   prop="date" align="center" label="GOP" >
					   <template slot-scope="scope">
							{{scope.row.gop}} s
					   </template>
				</el-table-column>
				<!-- <el-table-column prop="date" align="center" :label="$t('live.fenbianlv')"  >
					   <template slot-scope="scope">
						   <el-button-group>
							<el-button size="mini" plain type="info" v-auth="'editAdmin'" @click="openModel(scope.row,10)">{{$t('cdnd.edit')}}</el-button>
							<el-button @click="deleteItem({id:scope.row.log_id})" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						   </el-button-group>
						
					   </template>
												
				</el-table-column> -->
				
				
				
				<el-table-column align="center"  prop="remark" :label="$t('liveModel.remark')">
		
				</el-table-column>
				
			
				
							
				
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
			
			
				
				
				
		
				<el-table-column :width="layout.user.type==1?140:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						 <el-button-group>
							<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('cdnd.edit')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						   </el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<!-- 自适应模板 -->
			<el-table v-show="type=='ztran'" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"  >
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				
				
				<el-table-column  type="expand" :label="$t('liveModel.zi')">
						<template slot-scope="props">
							<el-table  v-loading="props.row.load"  stripe  :data="props.row.data" style="width: calc(100% - 150px);padding-left: 60px;" >
								

								<el-table-column width="120" align="center" prop="s_name" :label="$t('liveModel.name')">
								
								
								</el-table-column>
								
								
								
								
								
								<el-table-column   prop="date" align="center" :label="$t('live.modelType')" >
								   <template slot-scope="scope">
										<span v-if="scope.row.video_type==1">{{$t('live.videoType1')}}</span>
										<span v-if="scope.row.video_type==2">{{$t('live.videoType2')}}</span>
								   </template>
								</el-table-column>
								<el-table-column  prop="date" align="center" :label="$t('live.ma_type')" >
									   <template slot-scope="scope">
											<span v-if="scope.row.code_type==264">H.264</span>
											<span v-if="scope.row.code_type==265">H.265</span>
									   </template>
								</el-table-column>
								<el-table-column   prop="date" align="center" :label="$t('live.videoBitrate')" >
									   <template slot-scope="scope">
											<span v-if="scope.row.ma_type==1">{{scope.row.ma_value}} kbps</span>
											<span v-if="scope.row.ma_type==2">{{$t('live.setMa2')}}</span>
									   </template>
								</el-table-column>
								<el-table-column width="300" prop="date" align="center" :label="$t('live.fenbianlv')"  >
								   <template slot-scope="scope">
									   
									   <span v-if="scope.row.wh_type==1">
										   <span>{{$t('live.height')}}：{{scope.row.wh_value}} px</span>&nbsp;
										   <span>{{$t('live.width')}}</span>
									   </span>
									   <span v-if="scope.row.wh_type==2">{{$t('live.setWH2')}}</span>
									   
									   
								   </template>
																
								</el-table-column>
								
								<el-table-column   prop="date" align="center" :label="$t('live.videoFrameRate')" >
									   <template slot-scope="scope">
											<span v-if="scope.row.z_type==1">{{scope.row.z_value}} fps</span>
											<span v-if="scope.row.z_type==2">{{$t('live.setZ2')}}</span>
									   </template>
								</el-table-column>
								
								<el-table-column   prop="date" align="center" label="GOP" >
									   <template slot-scope="scope">
											{{scope.row.gop}} s
									   </template>
								</el-table-column>
							</el-table>
						</template>
					   </el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				<el-table-column prop="name" align="center" :label="$t('live.modelName')" >
					<template slot-scope="scope">
						{{scope.row.key}}{{scope.row.name}}
					</template>
				</el-table-column>
												
												
				
				<el-table-column align="center"  prop="user_name" :label="$t('cdn.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				
		
				<el-table-column align="center"  prop="remark" :label="$t('liveModel.num')">
					<template slot-scope="scope">
						{{scope.row.data.length}}
					</template>
				</el-table-column>
				
				
				<el-table-column align="center"  prop="remark" :label="$t('liveModel.remark')">

				</el-table-column>
				
			
				
							
				
				
				
				<el-table-column align="center"  prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
	
			
				
				
				
		
				<el-table-column :width="layout.user.type==1?140:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						 <el-button-group>
							<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('cdnd.edit')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						   </el-button-group>
					</template>
				</el-table-column>
			</el-table>
		
			<!-- 录制模版 -->
			<el-table v-show="type=='record'" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" >
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				
				
				
				
				<el-table-column prop="name" align="center" :label="$t('live.modelName')" >
					<template slot-scope="scope">
						{{scope.row.key}}{{scope.row.name}}
					</template>
				</el-table-column>
												
												
				
				<el-table-column align="center"  prop="user_name" :label="$t('cdn.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				
				<el-table-column  prop="date" align="center" label="HLS" >
					   <template slot-scope="scope">
							<span class="text-success" v-if="scope.row.data.hlsStatus==1">{{$t('cdnd.open')}}</span>
							<span class="text-danger" v-if="scope.row.data.hlsStatus==0">{{$t('cdnd.close')}}</span>
					   </template>
				</el-table-column>
				
				<el-table-column  prop="date" align="center" label="FLV" >
					   <template slot-scope="scope">
							<span class="text-success" v-if="scope.row.data.flvStatus==1">{{$t('cdnd.open')}}</span>
							<span class="text-danger" v-if="scope.row.data.flvStatus==0">{{$t('cdnd.close')}}</span>
					   </template>
				</el-table-column>
				
				<el-table-column  prop="date" align="center" label="MP4" >
					   <template slot-scope="scope">
							<span class="text-success" v-if="scope.row.data.mp4Status==1">{{$t('cdnd.open')}}</span>
							<span class="text-danger" v-if="scope.row.data.mp4Status==0">{{$t('cdnd.close')}}</span>
					   </template>
				</el-table-column>
				
				
				
				
				
		
				
				
				
				<el-table-column align="center"  prop="remark" :label="$t('liveModel.remark')">
					
				</el-table-column>
				
			
				
							
				
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
			
			
				
				
				
					
				<el-table-column :width="layout.user.type==1?140:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						 <el-button-group>
							<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('cdnd.edit')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						   </el-button-group>
					</template>
				</el-table-column>
			</el-table>
			
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('liveModel.edit') : $t('liveModel.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<div>
					<el-form-item  :label="$t('cdn.user')" prop="uid">
						<el-select @change="getMainAccount" :disabled="editIndex > -1" v-model="form.uid" size="small" filterable :placeholder="$t('system.select')">
						
							<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item  :label="$t('live.modelName')" prop="name">
						
						<el-input :maxlength="form.name_max" :disabled="editIndex>-1" size="small" style="width: 30%" :placeholder="$t('live.modelName')"   v-model="form.name">
						    <template slot="prepend">{{form.key}}</template>
						  </el-input>
						  <div style="font-size: 12px;color: gray;">{{$t('live.nameTis')}}</div>
						  
					</el-form-item>
					
					
					
					<el-form-item  :label="$t('liveModel.remark')" prop="remark">
						
						<el-input  size="small" style="width: 30%" :placeholder="$t('liveModel.remark')"   v-model="form.remark">
						  </el-input>
						  
					</el-form-item>
					
					
					<!-- 转码配置 -->
					<div v-if="type=='tran'">
						<el-form-item  :label="$t('live.transferType')" prop="video_type">
							
							<el-radio-group v-model="form.video_type"  :disabled="editIndex > -1" size="small">
							      <el-radio-button :label="1" >{{$t('live.videoType1')}}</el-radio-button>
								  <el-radio-button :label="2">{{$t('live.videoType2')}}</el-radio-button>
							      
							      
							    </el-radio-group>
						</el-form-item>
						<el-form-item  :label="$t('live.videoTj')" prop="tj">
							
							<el-radio-group @input="selVideoP" v-model="form.tj" size="small">
							      <el-radio-button :label="360">{{$t('live.pname1')}}</el-radio-button>
								  <el-radio-button :label="540">{{$t('live.pname2')}}</el-radio-button>
							      <el-radio-button :label="720">{{$t('live.pname3')}}</el-radio-button>
							      <el-radio-button :label="1080">{{$t('live.pname4')}}</el-radio-button>
							     <!-- <el-radio-button :label="1440">1440P</el-radio-button>
							      -->
							    </el-radio-group>
						</el-form-item>
						
						<el-form-item  :label="$t('live.videoBitrate')" :prop="form.ma_type == 1 ? 'ma_value' : ''" >
							
							<div style="display: flex;align-items: center;">
								<el-select style="width: 20%" v-model="form.ma_type" size="small" :placeholder="$t('system.select')">
									<el-option :label="$t('live.setMa1')" :value="1"></el-option>
									<el-option :label="$t('live.setMa2')" :value="2"></el-option>
									
								</el-select>
								<el-input v-if="form.ma_type==1" size="small" style="width: 30%" placeholder="101~8000" @blur="val => limitRange('ma_value', 101, 8000)" type="number" v-model="form.ma_value">
								    <template slot="append">kbps</template>
								</el-input>
								  
								  
								  
								  
							</div>
							
						</el-form-item>
						
						<el-form-item  :label="$t('live.videoResolution')" prop="wh_value">
							
							<div style="display: flex;align-items: center;">
								<el-select style="width: 20%" v-model="form.wh_type" size="small" :placeholder="$t('system.select')">
									<el-option :label="$t('live.setWH1')" :value="1"></el-option>
									<el-option :label="$t('live.setWH2')" :value="2"></el-option>
									
								</el-select>
								<el-input size="small" v-if="form.wh_type==1" style="width: 30%" placeholder="0~3000" @blur="val => limitRange('wh_value', 0, 3000)" type="number" v-model="form.wh_value">
								    <template slot="append">px</template>
								  </el-input>
							</div>
							
							
							  <div style="font-size: 12px;color: gray;">{{$t('live.tranTis')}}</div>
						</el-form-item>
						
						<el-form-item  :label="$t('live.videoCoding')" prop="code_type">
							
							<el-radio-group v-model="form.code_type" size="small">
								<el-radio :label="264" >H.264</el-radio>
								<el-radio :label="265" >H.265</el-radio>
							</el-radio-group>
							
						</el-form-item>
						
						
						<el-form-item  :label="$t('live.videoFrameRate')" :prop="form.z_type==1?'z_value':''">
							
							<div style="display: flex;align-items: center;">
								<el-select style="width: 20%" v-model="form.z_type" size="small" :placeholder="$t('system.select')">
									<el-option :label="$t('live.setZ1')" :value="1"></el-option>
									<el-option :label="$t('live.setZ2')" :value="2"></el-option>
								</el-select>
								<el-input size="small" v-if="form.z_type==1" style="width: 30%" placeholder="1~60" @blur="val => limitRange('z_value', 1, 60)" type="number" v-model="form.z_value">
								    <template slot="append">fps</template>
								  </el-input>
							</div>
							
						</el-form-item>
						
						<el-form-item  label="GOP" prop="gop">
							
							<el-input size="small" style="width: 50%;" placeholder="2~6s" @blur="val => limitRange('gop', 2, 6)" type="number" v-model="form.gop">
							    <template slot="append">s</template>
							  </el-input>
							  
							  <div style="font-size: 12px;color: gray;">{{$t('live.tranTis2')}}</div>
							
						</el-form-item>
					</div>
					
					
					<!-- 自适应码率 -->
					<div  v-if="type=='ztran'">
						<div v-for="(item, index) in form.list" :key="index" class="pl-5">
							<el-card class="box-card mt-3" >
								 <div slot="header" class="clearfix">
								    <span class="body_head">{{$t('liveModel.zi')+(index+1)}}</span>
									
									<el-button  @click="removeTranscode(index)" v-if="form.list.length>1" class="float-right" size="mini" type="danger" icon="el-icon-close" circle></el-button>
								
								  </div>
								  
								 
								 <div>
									 <!-- 子流名称 -->
									 <el-form-item 
									 :prop="'list.' + index + '.name'"  
									 :rules="[{ required: true, message: $t('live.noNull'), trigger: 'blur' }]"
									 :label="$t('liveModel.name')" 
									 >
									 	
									 	<el-input :maxlength="form.name_max" :disabled="editIndex>-1 && item.id!=0" size="small" style="width: 30%" :placeholder="$t('liveModel.name')"   v-model="item.name">
									 	    <template slot="prepend">{{form.key}}</template>
									 	  </el-input>
									 	  <div style="font-size: 12px;color: gray;">{{$t('live.nameTis')}}</div>
									 	  
									 </el-form-item>
									 
									 <!-- 转码类型 -->
									 <el-form-item  
									 :label="$t('live.transferType')" 
									 prop="video_type"
									 >
									 	
									 	<el-radio-group v-model="item.video_type"  :disabled="editIndex > -1  && item.id!=0" size="small">
									 	      <el-radio-button :label="1" >{{$t('live.videoType1')}}</el-radio-button>
									 		  <el-radio-button :label="2">{{$t('live.videoType2')}}</el-radio-button>
									 	      
									 	      
									 	    </el-radio-group>
									 </el-form-item>
									 <!-- 推荐参数 -->
									 <el-form-item  :label="$t('live.videoTj')" prop="tj">
									 	
									 	<el-radio-group @input="val => selVideoPList(val, index)" v-model="item.tj" size="small">
									 	      <el-radio-button :label="360">{{$t('live.pname1')}}</el-radio-button>
									 		  <el-radio-button :label="540">{{$t('live.pname2')}}</el-radio-button>
									 	      <el-radio-button :label="720">{{$t('live.pname3')}}</el-radio-button>
									 	      <el-radio-button :label="1080">{{$t('live.pname4')}}</el-radio-button>
									 	     <!-- <el-radio-button :label="1440">1440P</el-radio-button>
									 	      -->
									 	    </el-radio-group>
									 </el-form-item>
									 <!-- 视频码率 -->
									 <el-form-item  
									 :label="$t('live.videoBitrate')" 
									 :prop="item.ma_type === 1 ? `list.${index}.ma_value` : ''"
									 :rules="[{ required: item.ma_type === 1?true:false, message: $t('live.inpvideoBitrate'), trigger: 'blur' }]"
									 >
									 	
									 	<div style="display: flex;align-items: center;">
									 		<el-select style="width: 20%" v-model="item.ma_type" size="small" :placeholder="$t('system.select')" @change="val => (val !== 1) && clearFieldError(`list.${index}.ma_value`)">
									 			<el-option :label="$t('live.setMa1')" :value="1"></el-option>
									 			<el-option :label="$t('live.setMa2')" :value="2"></el-option>
									 			
									 		</el-select>
									 		<el-input v-if="item.ma_type==1" size="small" style="width: 30%" placeholder="101~8000" @blur="val => limitRangeList(index,'ma_value', 101, 8000)" type="number" v-model="item.ma_value">
									 		    <template slot="append">kbps</template>
									 		  </el-input>
									 	</div>
									 	
									 </el-form-item>
									 
									 
									 <!-- 分辨率 -->
									 <el-form-item  
									 :label="$t('live.videoResolution')"
									  :prop="'list.' + index + '.wh_value'"
									      :rules="[{ required: true, message: $t('live.inpvideoResolution'), trigger: 'blur' }]"
									>
									 	
									 	<div style="display: flex;align-items: center;">
									 		<el-select style="width: 20%" v-model="item.wh_type" size="small" :placeholder="$t('system.select')">
									 			<el-option :label="$t('live.setWH1')" :value="1"></el-option>
									 			<el-option :label="$t('live.setWH2')" :value="2"></el-option>
									 			
									 		</el-select>
									 		<el-input size="small" v-if="item.wh_type==1" style="width: 30%" placeholder="0~3000" @blur="val => limitRangeList(index,'wh_value', 0, 3000)" type="number" v-model="item.wh_value">
									 		    <template slot="append">px</template>
									 		  </el-input>
									 	</div>
									 	
									 	
									 	  <div style="font-size: 12px;color: gray;">{{$t('live.tranTis')}}</div>
									 	
									 </el-form-item>
									 <!-- 视频编码 -->
									 <el-form-item  :label="$t('live.videoCoding')" prop="code_type">
									 	
									 	<el-radio-group v-model="item.code_type" size="small">
									 		<el-radio :label="264" >H.264</el-radio>
									 		<el-radio :label="265" >H.265</el-radio>
									 	</el-radio-group>
									 	
									 </el-form-item>
									 
									 <!-- 帧率 -->
									 <el-form-item  
									 :label="$t('live.videoFrameRate')" 
									 :prop="item.z_type === 1 ? `list.${index}.z_value` : ''"
									 :rules="[{ required: item.z_type === 1?true:false, message: $t('live.noNull'), trigger: 'blur' }]"
									 >
									 	
									 	<div style="display: flex;align-items: center;">
									 		<el-select style="width: 20%" v-model="item.z_type" size="small" :placeholder="$t('system.select')" @change="val => (val !== 1) && clearFieldError(`list.${index}.z_value`)">
									 			<el-option :label="$t('live.setZ1')" :value="1"></el-option>
									 			<el-option :label="$t('live.setZ2')" :value="2"></el-option>
									 		</el-select>
									 		<el-input size="small" v-if="item.z_type==1" style="width: 30%" placeholder="1~60" @blur="val => limitRangeList(index,'z_value', 1, 60)" type="number" v-model="item.z_value">
									 		    <template slot="append">fps</template>
									 		  </el-input>
									 	</div>
									 	
									 </el-form-item>
									 
									 <!-- GOP -->
									 <el-form-item  label="GOP" 
									 :prop="'list.' + index + '.gop'"
									 :rules="[{ required: true, message: $t('live.noNull'), trigger: 'blur' }]"
									 >
									 	
									 	<el-input size="small" style="width: 50%;" placeholder="2~6s" @blur="val => limitRangeList(index,'gop', 2, 6)" type="number" v-model="item.gop">
									 	    <template slot="append">s</template>
									 	  </el-input>
									 	  
									 	  <div style="font-size: 12px;color: gray;">{{$t('live.tranTis2')}}</div>
									 	
									 </el-form-item>
								 </div>
								
							  
							</el-card>
							
							
						</div>
						
						<div class="my-4 ml-5">
							<el-button @click="addTranscode" :disabled="form.list.length>=15" size="mini" type="success">{{$t('liveModel.addZi')}}</el-button>
						</div>
					</div>
					
					
					<!-- 录制配置 -->
					<div v-if="type=='record'">
						<el-form-item   :label="$t('live.recordType')" prop="sel">
							<el-checkbox-group v-model="form.sel">
							      <el-checkbox label="HLS"></el-checkbox>
							      <el-checkbox label="FLV"></el-checkbox>
							      <el-checkbox label="MP4"></el-checkbox>
							    </el-checkbox-group>
							
						</el-form-item>
						
						
						<el-card v-if="form.sel.includes('HLS')" class="box-card mt-3 ml-5" >
								<div slot="header" class="clearfix">
								    <span class="body_head">HLS{{$t('live.rule')}}</span>
								</div>
								
								<el-form-item label-width="150px"  :label="$t('live.recordMinute')" prop="hlsMinute2">
									<span style="font-size: 12px;">{{$t('live.noTimeSet')}}</span>
									<!-- <el-input size="small" style="width: 50%;" placeholder="5~360" @blur="val => limitRange('hlsMinute', 5, 360)" type="number" v-model="form.hlsMinute">
									    <template slot="append">{{$t('live.minute')}}</template>
									</el-input> -->
									
								</el-form-item>
								
								
								<el-form-item label-width="150px"  :label="$t('live.recordSecond')" prop="hlsSecond">
									
									<el-input size="small" style="width: 50%;" placeholder="1-1800" @blur="val => limitRange('hlsSecond', 1, 1800)" type="number" v-model="form.hlsSecond">
									    <template slot="append">{{$t('live.second')}}</template>
									  </el-input>
									
								</el-form-item>
								
								
								  
							</el-card>
							
							<el-card v-if="form.sel.includes('FLV')" class="box-card mt-3 ml-5" >
								<div slot="header" class="clearfix">
								    <span class="body_head">FLV{{$t('live.rule')}}</span>
								</div>
								
								<el-form-item label-width="150px"  :label="$t('live.recordMinute')" prop="flvMinute">
									
									<el-input size="small" style="width: 50%;" placeholder="5~360" @blur="val => limitRange('flvMinute', 5, 360)" type="number" v-model="form.flvMinute">
									    <template slot="append">{{$t('live.minute')}}</template>
									  </el-input>
									
								</el-form-item>
								  
							</el-card>
							
							<el-card v-if="form.sel.includes('MP4')" class="box-card mt-3 ml-5" >
								<div slot="header" class="clearfix">
								    <span class="body_head">MP4{{$t('live.rule')}}</span>
								</div>
								
								<el-form-item label-width="150px"  :label="$t('live.recordMinute')" prop="mp4Minute">
									
									<el-input size="small" style="width: 50%;" placeholder="5~360" @blur="val => limitRange('mp4Minute', 5, 360)" type="number" v-model="form.mp4Minute">
									    <template slot="append">{{$t('live.minute')}}</template>
									  </el-input>
									
								</el-form-item>
								  
							</el-card>
						
					</div>
					
				</div>
				
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('accountList.editStatusRemark')"
			:visible.sync="remarkModel"
			top="5vh"
			ref="form"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_remark" ref="form_remark" :model="form_remark" :label-width="layout.is_phone?'80px':'100px'">
		
				
				<el-form-item :label="$t('accountList.remark')" prop="remark">
					<el-input v-model="form_remark.remark" :placeholder="$t('accountList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="remarkModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitRemark">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				remarkModel:false,
				createModel: false,
				editIndex: -1,
				type:"tran",
				//搜索數据
				from: {
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				},
				auth_val: 'LiveModel',
				odds:0,
				preUrl: "data/livemodelList", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/delLivedomainmodel", //删除單条地址
				addUrl: "data/addLivedomainModel", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {
					list:[],
					sel:[]
				},
				form_remark:{
				},
				rules_remark:{
					remark: [{
						required: true,
						message: this.$t('accountList.inpStatusRemark'),
						trigger: 'blur',
					}],
				},
				rules: {
					ma_value: [{
						required: true,
						message: this.$t('live.inpvideoBitrate'),
						trigger: 'blur',
					}],
					resolution: [{
						required: true,
						message: this.$t('live.inpvideoResolution'),
						trigger: 'blur',
					}],
					z_value: [{
						required: true,
						message: this.$t('live.noNull'),
						trigger: 'blur',
					}],
					gop: [{
						required: true,
						message: this.$t('live.noNull'),
						trigger: 'blur',
					}],
					name: [{
						required: true,
						message: this.$t('live.noNull'),
						trigger: 'blur',
					}],
					sel: [{
						required: true,
						message: this.$t('live.selrecordType'),
						trigger: 'blur',
					}],
					hlsMinute: [{
						required: true,
						message: this.$t('live.inprecordMinute'),
						trigger: 'blur',
					}],
					flvMinute: [{
						required: true,
						message: this.$t('live.inprecordMinute'),
						trigger: 'blur',
					}],
					mp4Minute: [{
						required: true,
						message: this.$t('live.inprecordMinute'),
						trigger: 'blur',
					}],
					hlsSecond: [{
						required: true,
						message: this.$t('live.inprecordSecond'),
						trigger: 'blur',
					}],
					uid: [{
						required: true,
						message: this.$t('cdn.selUser'),
						trigger: 'blur',
					}],
					list: {
						type: 'array',
						required: true,
						message: this.$t('live.haveMinOne'),
						trigger: 'blur'
					}
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
			'form.ma_type'(val) {
				this.$refs.form && this.$refs.form.clearValidate(['ma_value']);
			},
			'form.z_type'(val) {
				this.$refs.form && this.$refs.form.clearValidate(['z_value']);
			}
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('liveDomainModel');
		},
		methods: {
			clearFieldError(path) {
			    this.$refs.form && this.$refs.form.clearValidate([path]);
			  },
			openTable(row){
				return false;
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/liveDomainModelZi', {
						id:row.id,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
			},
			selVideoPList(e, index) {
			  const item = this.form.list[index];
			  item.ma_type = 1;
			  item.wh_type = 1;
			
			  if (e === 360) {
			    item.ma_value = 400;
			    item.wh_value = 360;
			  } else if (e === 540) {
			    item.ma_value = 700;
			    item.wh_value = 540;
			  } else if (e === 720) {
			    item.ma_value = 1000;
			    item.wh_value = 740;
			  } else if (e === 1080) {
			    item.ma_value = 2000;
			    item.wh_value = 1080;
			  } else if (e === 1440) {
			    item.ma_value = 3000;
			    item.wh_value = 1440;
			  }
			},
			selVideoP(e){
				console.log(e)
				this.form.ma_type=1
				this.form.wh_type=1
				if(e==360){
					this.form.ma_value=400
					this.form.wh_value=360
				}
				if(e==540){
					this.form.ma_value=700
					this.form.wh_value=540
				}
				if(e==720){
					this.form.ma_value=1000
					this.form.wh_value=740
				}
				if(e==1080){
					this.form.ma_value=2000
					this.form.wh_value=1080
				}
				if(e==1440){
					this.form.ma_value=3000
					this.form.wh_value=1440
				}
			},
			limitRangeList(index, field, min = 15, max = 360) {
				let val = this.form.list[index][field]
			  const num = Number(val);
			  if (isNaN(num)) return;
			
			  if (num < min) this.form.list[index][field] = min;
			  else if (num > max) this.form.list[index][field] = max;
			  else this.form.list[index][field] = num;
			},
			limitRange(field, min = 15, max = 360) {
				let val = this.form[field]
			    const num = Number(val);
			    if (isNaN(num)) return;
			
			    if (num < min) this.form[field] = min;
			    else if (num > max) this.form[field] = max;
			    else this.form[field] = num;
			  },
			getBtnType(status){
				if(status==1){
					return 'success';
				}else if(status==0){
					return 'danger';
				}else if(status==3){
					return 'warning';
				}else{
					return 'info';
				}
			},
			changeAcStatus(data){
				this.form_remark = {
					id:data.id,
					status:data.status,
					remark:''
				}
			
				this.remarkModel = true
			},
			submitRemark(){
				this.$refs.form_remark.validate(res => {
					
					if (res) {
						this.changeAcStatusApi(this.form_remark)
					}
				})
			},
			changeAcStatusApi(data){
				//this.layout.loading = true;
				this.axios.post(this.changeStatusUrl(), {
					id: data.id,
					remark: data.remark,
					status: data.status,
					type: 'account_status',
				}, {
					token: true,
				}).then(res => {
					let all = res.data;
					console.log(all)
					if (all.code == 1) {
						this.$message({
							message:all.msg,
							type: 'success'
						});
						let index  = this.tableData.findIndex(item=>item.id == data.id)
						this.tableData[index].account_status = data.status
						if(data.status==2){
							this.getList()
						}
					}
					this.remarkModel = false
					//this.layout.loading = false;
				}).catch(err => {
					//this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			getMainAccount(e){
				this.form.key = 'F'+this.form.uid
				
				this.form.name_max = 10 - this.form.key.length;
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changePassShowEmail(item){
				item.showPassEmail = item.showPassEmail==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
			addTranscode() {
			    this.form.list.push({
				  id:0,
			      tj:0,
			      name:'',
			      video_type:1,
			      code_type:264,
			      ma_type:1,
			      ma_value:'',
			      wh_type:1,
			      wh_value:0,
			      z_type:1,
			      z_value:'',
			      gop:2,
			    });
			  },
			  removeTranscode(index) {
			      this.form.list.splice(index, 1);
			    },

			// 打开模态框
			openModel(e = false) {
				// 增加
				console.log(e)
				
				if (!e) {
					
					if(this.type=='ztran'){
						// 初始化表單
						this.form = {
							id:0,
							type:this.type,
							remark:'',
							tj:0,
							name:'',
							key:'',
							uid:'',
							sel:[],
							name_max:10,
							list:[
								{
									id:0,
									tj:0,
									name:'',
									video_type:1,
									code_type:264,
									ma_type:1,
									ma_value:'',
									wh_type:1,
									wh_value:0,
									z_type:1,
									z_value:'',
									gop:2,
								}
							]
						}
					}else if(this.type=='record'){
						this.form = {
							id:0,
							remark:'',
							type:this.type,
							name:'',
							key:'',
							sel:[],
							hlsMinute:'',
							hlsSecond:'',
							
							flvMinute:'',
							name_max:15,
							mp4Minute:'',
						}
					}else{
						// 初始化表單
						this.form = {
							id:0,
							remark:'',
							type:this.type,
							tj:0,
							name:'',
							key:'',
							video_type:1,
							code_type:264,
							ma_type:1,
							ma_value:'',
							wh_type:1,
							wh_value:0,
							z_type:1,
							z_value:'',
							uid:'',
							gop:2,
							list:[],
							sel:[],
							name_max:10,
						}
					}
					
					this.editIndex = -1
				} else {
					// 修改
					if(this.type=='ztran'){
						
						this.form = {
							id:e.id,
							type:this.type,
							tj:0,
							remark:e.remark,
							name:e.name,
							key:e.key,
							sel:[],
							uid:e.uid,
							name_max:10,
							list:e.data,
						}
						
						
					}else if(this.type=='record'){
						
						this.form = {
							id:e.id,
							type:this.type,
							remark:e.remark,
							name:e.name,
							key:e.key,
							sel:[],
							hlsMinute:e.data.hlsMinute,
							hlsSecond:e.data.hlsSecond,
							
							flvMinute:e.data.flvMinute,
							
							mp4Minute:e.data.mp4Minute,
							uid:e.uid,
							name_max:15,
						}
						
						if (e.data.hlsStatus){
							 this.form.sel.push('HLS')
						}
						if (e.data.flvStatus){
							 this.form.sel.push('FLV')
						}
						if (e.data.mp4Status) {
							this.form.sel.push('MP4')
						};
						
						
					}else{
						this.form = {
							id:e.id,
							type:this.type,
							tj:0,
							remark:e.remark,
							name:e.name,
							key:e.key,
							video_type:e.video_type,
							code_type:e.code_type,
							ma_type:e.ma_type,
							ma_value:e.ma_value,
							wh_type:e.wh_type,
							wh_value:e.wh_value,
							z_type:e.z_type,
							z_value:e.z_value,
							gop:e.gop,
							uid:e.uid,
							name_max:10,
							list:[],
							sel:[],
						}
					}
					
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					
					
					
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
